<template>
  <div class="home xlbox" :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="线损计量"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
    />
    <div class="tj historyDiares" :style="{ height: pageHeight-110 + 'px' }">
      <van-sticky :offset-top="46" v-show="!nodataShow">
        <ul>
          <van-row>
            <van-col span="8">时间</van-col>
            <van-col span="6">正向有功表码</van-col>
            <van-col span="5">日电量(二次）</van-col>
            <van-col span="5">日电量(一次）</van-col>
          </van-row>
          <!-- <li style="width:37.5%">时间</li>
          <li style="width:20.83%">正向有功表码</li>
          <li style="width:20.83%">日电量(二次）</li>
          <li style="width:20.83%">日电量(一次）</li> -->
        </ul>
      </van-sticky>
      <van-empty description="没有数据啦~" v-show="nodataShow"/>
      <ul class="van-cell-group" v-show="!nodataShow">
        <li class="van-cell" v-for="(item, index) in list" :key="index">
          <van-row>
            <van-col span="8">{{item.time}}</van-col>
            <van-col span="6">{{item.zxygdnsz}}</van-col>
            <van-col span="5">{{item.dqzxygdnsz}}</van-col>
            <van-col span="5">{{item.dqzxwgdnsz}}</van-col>
          </van-row>
        </li>
        <!-- <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>

        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li>
        <li class="van-cell">
          <van-row>
            <van-col span="9">2021/02/24 10:30:19</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">10.06</van-col>
            <van-col span="5">130.2</van-col>
          </van-row>
        </li> -->
      </ul>

    </div>
    <van-pagination
      v-model="currentPage"
      :page-count="totalPage"
      mode="simple"
      @change="changePage"
      v-show="!nodataShow"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Sticky,
  Toast,
  Pagination,
  Empty
} from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Cell,
  CellGroup,
  Button,
  Icon,
  NavBar,
  List,
  PullRefresh,
  DropdownMenu,
  DropdownItem,
  Sticky,
  Toast,
  Pagination,
  Empty
)

export default {
  name: 'XSJLPage',
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Sticky.name]: Sticky,
    [Toast.name]: Toast,
    [Pagination.name]: Pagination,
    [Empty.name]: Empty
  },
  data () {
    return {
      nodataShow: false,
      isLoading: false,
      loading: false,
      finished: false,
      pageHeight: window.innerHeight,
      mlineId: '', // 线路id
      elepoId: '3号杆塔',
      currentPage: 1, // 当前页
      totalPage: '', // 总页数
      pagesize: 20, // 每页显示条数
      list: []

    }
  },
  created () {
    // console.log(222)
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    // console.log(this.mlineId)
    // console.log(this.elepoId)
    this.getXSJLList()
  },
  activated () {
    // console.log(1111)
    // 如果要在每次进入页面的时候获取最新的数据，需要在activated阶段获取数据，承担原来created钩子中获取数据的任务。
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
    this.getXSJLList()
  },
  mounted () {
    this.mlineId = this.$route.query.mlineId // 传过来的线路id
    this.elepoId = this.$route.query.elepoId
  },
  methods: {
    onClickLeft () {
      // window.history.back()
      this.$router.go(-1) // 返回上一页面
    },
    getXSJLList () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      this.util
        .post('/getXSJL', {
          currentPage: this.currentPage, // 当前页
          pagesize: this.pagesize, // 每页显示条数
          mlineId: this.mlineId, // 线路id
          elepoId: this.elepoId // 杆塔id
        })
        .then(({ data }) => {
          if (data.code === 200) {
            console.log(data)
            this.list = data.data.list
            console.log(this.list)
            if (this.list.length > 0) {
              this.nodataShow = false
            } else {
              this.nodataShow = true
            }
            this.totalPage = data.data.totalPage
            console.log(this.totalPage)
            this.$nextTick(() => {
              Toast.clear() // 手动清除 Toast
            })
          } else {
            return Promise.reject(
              new Error(data.message || data.msg || '系统错误，请稍后再试。')
            )
          }
        })
    },
    changePage () {
      // 页码改变时触发
      // console.log(this.currentPage)
      this.getXSJLList()
    }

  },
  computed: {

  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar{
  background: linear-gradient(227deg, #06C8B5 0%, #007CF8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-dropdown-menu__bar {
  width: 100vw;
  height: 34px;
  position: fixed;
  left: 0;
  top: 56px;
  z-index: 2;
}
/deep/.van-sticky .van-col{
  color: #a2a1a0;
}
/deep/.van-col{
  padding: 0 5px 0 0;
}
.home {
  background: #fff;
  overflow-y: hidden;
}
.tj{
  width: 100%;
  margin-top: 46px;
  margin-bottom: 10px;
  border-bottom: 1px solid #F9F9F9;
  overflow-y: auto;
}
.van-cell-group .van-cell:nth-child(even) {
  background: #f9f9f9;
}
.van-cell .van-row{
  width: 100%;
}
/deep/.van-sticky{
  background: #fff;
  padding: 10px 16px;
}
.tj .van-sticky--fixed ul{
  padding: 0px 12px;
}
.van-sticky li{
  display: inline-block;
  color: #A2A1A0;
  font-size: 13px;
  vertical-align: top;
}
</style>
